export const taskBaseUrl = '/umbraco/api/ProjectTasks/';
export const projectUrls = {
  baseUrl: '/umbraco/api/Project/',
  getAssignedProjects: '/umbraco/api/Project/GetAssignedProjectsAsync',
  getProjectById: '/umbraco/api/Project/GetProjectByIdAsync',
  changePhaseOrder: '/umbraco/api/Project/ChangeProjectPhaseOrderAsync',
  createProjectPhase: '/umbraco/api/Project/CreateProjectPhase',
  renameProjectPhase: '/umbraco/api/Project/RenameProjectPhaseAsync',
  deleteProjectPhase: '/umbraco/api/Project/DeleteProjectPhaseAsync',
};

export const fileUrls = {
  saveFile: '/umbraco/Api/FileStore/SaveFile',
  removeFile: '/umbraco/Api/FileStore/RemoveFile',
};

export const taskUrls = {
  baseUrl: '/umbraco/api/Task/',
  changeTaskEstimation: '/umbraco/api/Task/ChangeTaskEstimationAsync',
  changeTaskReleaseEstimation: '/umbraco/api/Task/ChangeTaskReleaseEstimationAsync',
};

export const settingsViewFrontend = {
  changeVisibilityPhase: '/umbraco/api/SettingsViewFrontend/ChangeVisibilityPhase',
};
export const kanbanBaseUrl = '/umbraco/api/Kanban/';
export const kanbanUrls = {
  getKanbanPermissionsForPhase: '/umbraco/api/Kanban/GetKanbanPermissionsForPhase',
  getBoardVisibilityRoles: '/umbraco/api/Kanban/GetBoardVisibilityRoles',
};
export const userManagementUrls = {
  getCurrentRoles: '/umbraco/api/UserManagment/GetCurrentRoles/',
};
export const relationsBaseUrl = '/umbraco/api/RelationMember/';
export const commentsBaseUrl = '/umbraco/api/Comments/';
export const gridBaseUrl = '/umbraco/api/Grid/';
